import React from 'react';
import {ContactSection} from '../components/ContactSection';
import {useSeo} from '../hooks/useSeo';

export function KontaktPage() {
    useSeo({
        title: 'Kontakt - Montaż kamer i Monitoring Mielec (39-300) | kamerymielec.pl',
        description:
            'Skontaktuj się z nami w sprawie montażu kamer i monitoringu w Mielcu oraz w promieniu do 250 km (Rzeszów, Tarnów, Dębica, Stalowa Wola, Tarnobrzeg, Sandomierz). Telefon: +48 664 896 662, ul. Wojska Polskiego 9/D211, Mielec.',
        canonicalPath: '/kontakt',
        keywords:
            'kontakt kamery Mielec, monitoring Mielec kontakt, montaż kamer Mielec telefon, adres monitoring Mielec, kamery mielec Wojska Polskiego',
        breadcrumbs: [
            {name: 'Strona główna', path: '/'},
            {name: 'Kontakt', path: '/kontakt'},
        ],
        jsonLd: {
            '@context': 'https://schema.org',
            '@type': 'ContactPage',
            name: 'Kontakt - Kamery Mielec',
            url: 'https://kamerymielec.pl/kontakt',
            inLanguage: 'pl-PL',
        },
    });

    return <ContactSection/>;
}
